import { __assign, __read, __rest, __spread } from "tslib";
import { fillWithEmptyKeys } from '../../../utils';
export var tableChartTransformation = function (result, analysisType, eventCollection) {
    var keys = new Set();
    var formattedResult = analysisType && eventCollection
        ? result.map(function (record) {
            var _a;
            var result = record.result, rest = __rest(record, ["result"]);
            return typeof result !== 'undefined'
                ? __assign(__assign({}, rest), (_a = {}, _a[analysisType + "." + eventCollection] = result, _a)) : record;
        })
        : result;
    formattedResult.forEach(function (record) {
        return Object.keys(record).forEach(function (keyName) { return keys.add(keyName); });
    });
    return {
        data: fillWithEmptyKeys(__spread(keys), formattedResult, ''),
        keys: __spread(keys),
    };
};
